import React from 'react'
import { Form, Formik } from 'formik'
import Div from '@jumbo/shared/Div'
import JumboCardQuick from '@jumbo/components/JumboCardQuick'
import JumboAppTextField from '@jumbo/components/JumboAppTextField'
import LoadingButton from '@mui/lab/LoadingButton'
import SearchIcon from '@mui/icons-material/Search'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import AutorenewRoundedIcon from '@mui/icons-material/AutorenewRounded'

const TermFilterGird = ({ mutation, display, filterIconColor }) => {
    let initialValues = {
        termYear: null,
        termNumber: null,
        termName: '',
    }

    const onFormSubmit = (termYear, termName, termNumber) => {
        mutation.mutate({
            termYear: termYear === '' ? null : termYear,
            termNumber: termNumber === '' ? null : termNumber,
            termName: termName,
            sort: 'termYear',
            isDescending: false,
        })
    }

    const onFilterSubmit = (data, { setSubmitting }) => {
        setSubmitting(true)
        onFormSubmit(data.termYear, data.termName, data.termNumber)
        setSubmitting(false)
    }

    const handleClear = (resetForm) => {
        resetForm({ values: { termYear: '', termNumber: '', termName: '' } })
        filterIconColor(false)
        mutation.mutate({
            termYear: null,
            termNumber: null,
            termName: '',
            sort: 'termYear',
            isDescending: false,
        })
    }

    const preventNegativeValues = (event) => {
        if (event.target.value < 0) {
            event.target.value = ''
        }
    }

    return (
        <Formik validateOnChange={true} initialValues={initialValues} onSubmit={onFilterSubmit}>
            {({ isSubmitting, resetForm }) => (
                <Form noValidate autoComplete='off'>
                    <JumboCardQuick noWrapper sx={{ display: display, borderRadius: 0 }}>
                        <Div
                            className='grid-filter-parent'
                            style={{ display: 'flex', margin: '0 1.5% 1.5% 1.5%', flexWrap: 'wrap' }}>
                            <Div sx={{ mr: 3, mt: 1.5 }}>
                                <Div>
                                    <Typography>Term Year</Typography>
                                </Div>
                                <Div sx={{ mt: 0.5 }}>
                                    <JumboAppTextField
                                        style={{ width: 220 }}
                                        size='small'
                                        type='number'
                                        name='termYear'
                                        inputProps={{ min: 0 }}
                                        onInput={preventNegativeValues}
                                    />
                                </Div>
                            </Div>
                            <Div sx={{ mr: 3, mt: 1.5 }}>
                                <Div>
                                    <Typography>Term Number</Typography>
                                </Div>
                                <Div sx={{ mt: 0.5 }}>
                                    <JumboAppTextField
                                        style={{ width: 220 }}
                                        size='small'
                                        type='number'
                                        name='termNumber'
                                        inputProps={{ min: 0 }}
                                        onInput={preventNegativeValues}
                                    />
                                </Div>
                            </Div>
                            <Div sx={{ mr: 3, mt: 1.5 }}>
                                <Div>
                                    <Typography>Term Name</Typography>
                                </Div>
                                <Div sx={{ mt: 0.5 }}>
                                    <JumboAppTextField style={{ width: 220 }} size='small' name='termName' />
                                </Div>
                            </Div>
                            <Div className='grid-filter-Button' sx={{ mt: 5 }}>
                                <Stack direction={'row'} spacing={1}>
                                    <LoadingButton
                                        size={'small'}
                                        type='submit'
                                        onClick={() => filterIconColor(true)}
                                        variant={'contained'}
                                        loading={isSubmitting || mutation.isLoading}>
                                        <SearchIcon sx={{ fontSize: 18 }} /> Search
                                    </LoadingButton>
                                    <LoadingButton
                                        size={'small'}
                                        type={'reset'}
                                        onClick={() => handleClear(resetForm)}
                                        variant={'contained'}>
                                        <AutorenewRoundedIcon sx={{ fontSize: 18 }} /> Clear
                                    </LoadingButton>
                                </Stack>
                            </Div>
                        </Div>
                    </JumboCardQuick>
                </Form>
            )}
        </Formik>
    )
}

export default TermFilterGird
